export {StaticSelect} from './static-select';
